import "./App.scss";
import "rsuite/dist/rsuite.min.css";
import Base from "./layouts";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import reduxStore from "./redux/index";
import { PersistGate } from "redux-persist/integration/react";
import "devextreme/dist/css/dx.light.css";
import "bootstrap/dist/css/bootstrap.css";
import "./themes/theme.scss";

const { store, persistor } = reduxStore();

function App() {
  return (
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <div className="App">
            <Base />
          </div>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
